import React, {useState, useEffect} from "react";
import assets from "../assets/imgs/index"
import MainTable from "../components/MainTable";
import config from "../config/config";
import {useUser} from "../context/UserContext";

const API_URL = config.API_URL;

function MyPageSystemAuthority() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const {authority, company} = useUser();

  const startupManager = (authority <= 4);


  const headTitles = [
    { key: 'check', label: '', searchable: false},
    { key: "_id", label : "_id", searchable: false},
    { key: 'account', label: '아이디'},
    { key: 'name', label: '성명'},
    { key: 'company', label: '기업명' },
    { key: 'owner', label: '기업 대표자'},
    { key: 'phone', label: '전화번호'},
    { key: 'email', label: '이메일'},
    { key: 'role', label: '직급'},
    { key: 'date', label: '날짜' },
    { key: 'authority', label: '권한상태 설정'},
  ];

  const testData = [
    { id: 1, date: "2024-01-01", company: "회사 A", client: "거래처 D", clientNumber: "1234567890", item: "상품 X", amount: 1000000, etc: "https://example.com" },
  ];

  const actionMenuItems = [
    ...(!startupManager ? [
      { key: "admin", label: "캠타 관리자", icon: <assets.icons.camp_admin /> },
      { key: "adminManager", label: "캠퍼스타운", icon: <assets.icons.key /> },
    ] : []),
    // { key: "admin", label: "캠타 관리자", icon:<assets.icons.camp_admin/>},
    // { key: "adminManager", label : "캠퍼스타운", icon: <assets.icons.key/>},
    { key: "resident", label: "입주사", icon: <assets.icons.pin/>},
    { key: "owner_auth", label : "대표 권한", icon: <assets.icons.leader_auth/>},
    { key: "owner", label : "입주사 대표", icon: <assets.icons.team/>},
    { key: "pending", label: "권한 요청 대기", icon: <assets.icons.redo_circle/>},
    { key: "delete", label: "삭제하기", icon: <assets.icons.bin style={{fill:"var(--system-danger_10)"}}/>, style: {color: "var(--system-danger_10)"}},
  ];

  const handleActionMenuClick = (key, row) => {
    if(key === "delete"){
      deleteUser(row._id);
      return;
    }
    let originAuthority = row.authority;
    let authorityId;
    switch (key) {
      case "admin":
        authorityId = 6;
        break;
      case "adminManager":
        authorityId = 5;
        break;
      
      case "owner":
        authorityId = 4;
        break;
      case "owner_auth":
        authorityId = 3;
        break;
      case "resident":
        authorityId = 2;
        break;
      
      case "pending":
        authorityId = 1;
        break;
      default:
        break;
    }

    updateAuthority(row._id, authorityId, originAuthority);
  };

  const updateAuthority = async (userId, authorityId, originAuthority) =>{
    if(authority <=5 && (authority < authorityId || authority < originAuthority)){
      alert('권한이 부족합니다.');
      return null;
    }
    if(authorityId === 4){
      const confirmOwner = window.confirm('입주자 대표는 스타트업당 1명만 가능합니다. 계속 진행하겠습니까?');
      if(!confirmOwner){
        return null;
      }
    }
    let degradeOwner= false;
    if(originAuthority === 4 && authorityId !== 4){
      const confirmOwner2 = window.confirm('해당 계정은 입주자 대표로 설정되어 있습니다.\n변경시 대표 계정 연결이 끊깁니다.\n계속 진행하시겠습니까?');
      if(!confirmOwner2){
        return null;
      }
      degradeOwner = true;
    }
    try {
      const response = await fetch(`${API_URL}/api/auth/updateUserInfo`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          user_id: userId,
          updateValues: { authority_id: authorityId },
          degradeOwner: degradeOwner,
        }),
      });

      if(response.status === 403){
        alert("권한이 부족합니다.");
        return;
      }
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const result = await response.json();
      console.log("Authority update response:", result);
  
      if (result.result) {
        if(result.pending){
          const confirmed = window.confirm(result.message);
          if(confirmed){
            const response2 = await fetch(`${API_URL}/api/auth/updateUserInfo`, {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
              },
              credentials: "include",
              body: JSON.stringify({
                user_id: userId,
                updateValues: { authority_id: authorityId },
                changeOwner: true,
              }),
            });
            if (!response2.ok) {
              throw new Error(`HTTP error! status: ${response2.status}`);
            }
            const result2 = await response2.json();
            if(result2.result){
              alert("사용자 권한이 성공적으로 업데이트되었습니다.");
            }else{
              alert("권한 업데이트 실패: " + result2.message);
            }
            window.location.reload();
          }else{
            alert('취소되었습니다.');
          }
          return null;   
        }

        alert("사용자 권한이 성공적으로 업데이트되었습니다.");
      } else {
        alert("권한 업데이트 실패: " + result.message);
      }
      window.location.reload();
    } catch (error) {
      console.error("Error updating authority:", error);
      alert("권한 업데이트 중 오류 발생.");
    }
  }

  const deleteUser = async (userId) =>{
    try {
      const response = await fetch(`${API_URL}/api/auth/deleteUser`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          user_id: userId,
        }),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const result = await response.json();
      console.log("delete user response:", result);
  
      if (result.result) {
        alert("해당 계정이 삭제되었습니다.");
      } else {
        alert("계정 삭제 실패: " + result.message);
      }
      window.location.reload();
    } catch (error) {
      console.error("Error deleting user:", error);
      alert("계정 삭제 중 오류 발생.");
    }
  }

  // API 호출 함수
  const fetchData = async () => {
    try {
      const response = await fetch(`${API_URL}/api/auth/getUserAuthList`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include"
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      // console.log(result.value);

      if (result.result) {
        // 데이터를 변환하여 company -> startup_name 매핑
        const formattedData = result.value.map((user, index) => ({
          _id: user.user_id || index + 1, // ID 설정
          account: user.account || '알 수 없음',
          name : user.name || '알 수 없음',
          company: user.startup_name || "알 수 없음", // startup_name 매핑
          owner: user.owner || '알 수 없음',
          phone: user.phone_nb || '알 수 없음',
          email: user.email || '알 수 없음',
          role : user.role || '미정',
          date: user.log_date ? user.log_date.split("T")[0] : "알 수 없음", // 날짜만 추출
          authority: user.authority_id || 0,
        }));
        setData(formattedData);
      } else {
        console.error("데이터 가져오기 실패:", result.message);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      // setError(error.message); // 에러 메시지 저장
    } finally {
      setLoading(false); // 데이터 로딩 완료
    }
  };
  useEffect(() => {
    fetchData();
  }, []);


  return(
    <div style={{flex: 1, display: 'flex', flexDirection: "column"}}>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <MainTable title="권한설정" tableHeadTitles={headTitles} tableData={data}
          onActionMenuClick={handleActionMenuClick} actionMenuItems={actionMenuItems}
          pageType={'mypage'} mainSearchKey="company"/>
      )}
    </div>
  );
}

export default MyPageSystemAuthority;